import { LoginCallback } from "@okta/okta-react";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import { AuthWrapper } from "./AuthWrapper";
import {
  customer360Paths,
  intelligenceHubPaths,
  leadsManagementPaths,
  rewardInventoryPortalPaths,
  rootPaths,
} from "./routePaths";
import { RequiredAuth } from "./SecureRoute";
import Loading from "../components/molecules/Loading";
import UnAuthorisedToUseApplication from "../components/molecules/UnAuthorisedToUseApplication";
import MainLayout from "../layouts/MainLayout";
import { SideMenuProvider } from "../layouts/SideMenuContext";
import Campaign from "../pages/campaign/Campaign";
import EngageSideMenu from "../pages/campaign/EngageMenu";
import Customer360 from "../pages/customer-360/Customer360";
import CustomerDetail from "../pages/customer-360/CustomerDetail/CustomerDetail";
import DNADashboard from "../pages/dnaDashboard/DNADashboard";
import AnalyticsPage from "../pages/intelligenceHub/AnalyticsPage";
import IntelligenceHubSideMenu from "../pages/intelligenceHub/IntelligenceHubSideMenu";
import SocialInsightsPage from "../pages/intelligenceHub/SocialInsightsPage";
import AllLeadsPage from "../pages/leads-management/AllLeadsPage";
import HomePage from "../pages/leads-management/HomePage";
import ImportLeadsPage from "../pages/leads-management/ImportLeadsPage";
import LeadsManagementSideMenu from "../pages/leads-management/LeadsManagementSideMenu";
import Pps from "../pages/pps/pps";
import CreateProduct from "../pages/reward-inventory-portal/create-product/CreateProduct";
import Product from "../pages/reward-inventory-portal/product/Product";
import RewardsInventory from "../pages/reward-inventory-portal/RewardsInventory";
import Tools from "../pages/Tools";

const router = createBrowserRouter([
  {
    element: <AuthWrapper />,
    children: [
      {
        path: rootPaths.tools,
        element: <RequiredAuth />,
        children: [
          {
            index: true,
            element: <Tools />,
          },
          {
            path: rootPaths.rewardInventoryPortal,
            element: (
              <MainLayout
                headerTitle="Rewards Inventory Portal"
                titleClickPath={rootPaths.rewardInventoryPortal}
              />
            ),
            children: [
              {
                index: true,
                element: <RewardsInventory />,
              },
              {
                path: rewardInventoryPortalPaths.createProduct,
                element: <CreateProduct />,
              },
              {
                path: rewardInventoryPortalPaths.product,
                element: <Product />,
              },
            ],
          },
          {
            path: rootPaths.customer360,
            element: (
              <MainLayout
                headerTitle="Omne DNA 360 "
                titleClickPath={rootPaths.customer360}
              />
            ),
            children: [
              {
                index: true,
                element: <Customer360 />,
              },
              {
                path: customer360Paths.customerDetail,
                element: <CustomerDetail />,
              },
            ],
          },
          {
            path: rootPaths.pps,
            element: (
              <MainLayout
                headerTitle="Omne PPS Tools "
                titleClickPath={rootPaths.pps}
              />
            ),
            children: [
              {
                index: true,
                element: <Pps />,
              },
            ],
          },
          {
            path: rootPaths.intelligenceHub,
            element: (
              <MainLayout
              headerTitle="Intelligence Hub"
                titleClickPath={rootPaths.intelligenceHub}
                sideMenuContent={<IntelligenceHubSideMenu/>}
              />
            ),
            children: [
              {
                index: true,
                element: <AnalyticsPage/>,
              },
               {
                path: intelligenceHubPaths.socialInsights,
                element: <SocialInsightsPage />,
              },
            ],
          },
          {
            path: rootPaths.leadsManagement,
            element: (
              <MainLayout
                headerTitle="Leads Management "
                titleClickPath={rootPaths.leadsManagement}
                sideMenuContent={<LeadsManagementSideMenu />}
                // hasSideMenu={true}
              />
            ),
            handle: {
              sideMenu: true,
              menuType: "leadsManagement",
            },
            children: [
              {
                index: true,
                element: <HomePage />,
              },
              {
                path: leadsManagementPaths.allLeads,
                element: <AllLeadsPage />,
              },
              {
                path: leadsManagementPaths.socialInsights,
                element: <SocialInsightsPage />,
              },
              {
                path: leadsManagementPaths.importLeads,
                element: <ImportLeadsPage />,
              },
            ]
          },
          {
            path: rootPaths.dna,
            element: (
              <MainLayout
                headerTitle="Leads Management "
                titleClickPath={rootPaths.dna}
              />
            ),
            children: [
              {
                index: true,
                element: <DNADashboard />,
              },
            ],
          },
           {
            path: rootPaths.campaign,
            element: (
              <MainLayout
                headerTitle="Campaign"
                titleClickPath={rootPaths.campaign}
                sideMenuContent={<EngageSideMenu />}
              />
            ),
            children: [
              {
                index: true,
                element: <Campaign />,
              },
            ],
          },
        ],
      },
      {
        path: rootPaths.signInRedirect,
        element: <LoginCallback loadingElement={<Loading />} />,
      },
      {
        path: rootPaths.unauthorised,
        element: <UnAuthorisedToUseApplication />,
      },
      {
        path: "*",
        element: <Navigate to={rootPaths.tools} />,
      },
    ],
  },
]);

const AppRoutes = () => {
  return (
    <SideMenuProvider>
      <RouterProvider router={router} />
    </SideMenuProvider>
  );
};

export default AppRoutes;
